import { render, staticRenderFns } from "./ruleDialog.vue?vue&type=template&id=4add47ec&"
import script from "./ruleDialog.vue?vue&type=script&lang=js&"
export * from "./ruleDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports